import { styled } from '@mui/material';
import { Stepper as MuiStepper } from '@mui/material';
import colors from '../../assets/colors';

const Stepper = styled(MuiStepper)({
  '.MuiStepConnector-line': {
    borderColor: colors.agroweGreen,
    borderTopWidth: '2px',
  },
  '.MuiSvgIcon-root.MuiStepIcon-root.Mui-active': {
    color: colors.agroweGreen,
  },
  '.MuiStepIcon-text': {
    fill: colors.white,
  },
  '.Mui-disabled': {
    '.MuiStepConnector-line': {
      borderColor: colors.yellow,
      borderTopWidth: '2px',
    },
    '.MuiStepIcon-root': { color: colors.yellow },
    '.MuiStepIcon-text': {
      fill: colors.black,
    },
  },
  '.Mui-completed': {
    '.MuiStepConnector-line': {
      borderColor: colors.agroweGreen,
      borderTopWidth: '2px',
    },
    '.MuiStepIcon-root': { color: colors.agroweGreen },
    '.MuiStepIcon-text': {
      fill: colors.white,
    },
  },
});

export default Stepper;
